<template>
  <div>
    <mensajeSistema></mensajeSistema>

    <!-- FILTROS Y SEARCHBAR -->
    <!-- <template>
      <v-row>
        <v-col cols="12" md="4">
          <AutocompleteComp @change="SeleccionarNivel" :items="niveles" v-model="nivelSelected" textLabel="Nivel"
            item-text="desc_nivel" item-value="id_nivel" return-object />
        </v-col>

        <v-col cols="12" md="4">
          <AutocompleteComp @change="SeleccionarGrado" :items="grados" v-model="gradoSelected" textLabel="Grado"
            item-text="desc_grado" item-value="id" return-object />
        </v-col>

        <v-col cols="12" md="4">
          <AutocompleteComp @change="SeleccionarSeccion" :items="secciones" v-model="seccionSelected"
            textLabel="Sección" item-text="nombre_seccion" item-value="id" return-object />
        </v-col>
      </v-row>
    </template> -->

    <!-- TABLA DE ESTUDIANTES -->
    <v-row dense>
      <v-col cols="12">
        <!-- <ComundataTablecomp
          :whitSearch="searchQuery"
          :headers="headers"
          :items="alumnos"
        > -->
        <template>
          <v-row>
            <v-col cols="12" class="d-flex align-center gap-10px">

              <ButtonComp @click="dialogConfi = true" textButton="Cierre del año" iconBut="fas fa-graduation-cap" />
            </v-col>
          </v-row>
        </template>

        <!-- <template v-slot:situacion="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  class="text-uppercase"
                  label
                  v-bind="attrs"
                  v-on="on"
                  :class="
                    item.nivel_logro_anual > 3.5
                      ? 'color_aprobado'
                      : item.nivel_logro_anual > 2.5
                      ? 'color_aprobado'
                      : item.nivel_logro_anual <= 1.49
                      ? 'color_desaprobado'
                      : 'color_recuperacion'
                  "
                  small
                >
                  {{
                    item.nivel_logro_anual > 3.5
                      ? "AD"
                      : item.nivel_logro_anual > 2.5
                      ? "A"
                      : item.nivel_logro_anual <= 1.49
                      ? "C"
                      : "B"
                  }}
                </v-chip>
              </template>
              <span>
                {{
                  item.nivel_logro_anual >= 2.5
                    ? "El alumno muestra un buen desempeño"
                    : item.nivel_logro_anual >= 1.5 &&
                      item.nivel_logro_anual < 2.49
                    ? "El alumno requiere fortalecer su base de conocimientos"
                    : "El alumno requiere apoyo prioritario"
                }}
              </span>
            </v-tooltip>
          </template>
        </ComundataTablecomp> -->
      </v-col>
    </v-row>

    <ComunDialogComp v-model="dialogConfi" Confirmdialog @close-modal="dialogConfi = false" titleWindow="Confirmar"
      @confirm-item="estadoComp = true" @cancel-item="dialogConfi = false">
      <template v-slot:body>
        ¿Para poder cerrar el año lectivo, se tiene que crear el siguiente año
        como paso previo. , tenga en cuenta que al cerrar el año se realizara la
        promoción, permanencia y recuperación de todos sus estudiantes?
      </template>
    </ComunDialogComp>

    <v-dialog v-model="dialogChart" scrollable max-width="40%">
      <v-card>
        <v-card-title class="modal_title py-5 mb-2">
          Estadísticas de los Estudiantes
        </v-card-title>
        <PieChart :chart-data="estadosAprobados" :chart-options="chartOptions" />
      </v-card>
    </v-dialog>

    <CrearNuevoAnioModal :estadoComp="estadoComp" @close="CloseComp" />
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations } from "vuex";
import ComundataTablecomp from "../../../components/ComponentsEst/ComundataTablecomp.vue";
import AutocompleteComp from "../../../components/ComponentsEst/AutocompleteComp.vue";
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";
import ComunDialogComp from "../../../components/ComponentsEst/ComunDialogComp.vue";
import CrearNuevoAnioModal from "./CrearNuevoAnioModal.vue";
import PieChart from "../../../components/ComponentsEst/Pie.vue";

export default {
  name: "CierreAñoySituacionEstudiante",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ComundataTablecomp,
    // eslint-disable-next-line vue/no-unused-components
    AutocompleteComp,
    ButtonComp,
    ComunDialogComp,
    CrearNuevoAnioModal,
    PieChart,
  },
  props: ["tabPosition"],
  data: () => ({
    id_colegio: parseInt(sessionStorage.getItem("id_colegio")),
    id_ano_lectivo: parseInt(sessionStorage.getItem("id_ano_lectivo")),
    alumnos: [],
    alumnosBackup: [],
    nivelesBackup: [],
    gradosBackup: [],

    headers: [
      {
        text: "Nombre y apellidos",
        value: "apellido_nombre",
        class: "header_datatable",
      },
      {
        text: "Nivel",
        value: "desc_nivel",
        class: "header_datatable",
      },
      {
        text: "Grado",
        value: "desc_grado",
        class: "header_datatable",
      },
      {
        text: "Sección",
        value: "nombre_seccion",
        class: "header_datatable",
      },
    ],
    nivelSelected: -1,
    gradoSelected: -1,
    seccionSelected: -1,
    searchQuery: "",
    niveles: [],
    grados: [],
    secciones: [],

    periodos: [],
    periodosDisableButton: true, //Boleano encargado de disablear o no el button de cierre final. (Cuando el ultimo periodo haya finalizado)

    dialogChart: false,
    dialogConfi: false,

    //Modal multisteper
    estadoComp: false,

    //PieChart -- Data no dinamica de momento
    estadosAprobados: {
      labels: ["Aprobados", "Jalados", "Recuperación"],
      datasets: [
        {
          backgroundColor: ["#4caf50", "#ec3f32", "#f5b808"],
          data: [10, 20, 70],
        },
      ],
    },

    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
    },
  }),

  /*_______________
  |   MONTADOR   */
  mounted() {
    this.loadMain();
  },
  watch: {
    tabPosition(valor) {
      if (valor == 0) {
        this.loadMain();
      }
    },
  },
  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    loadMain() {
      this.getNiveles(this.id_ano_lectivo, this.id_colegio);
      this.getAlumnos(this.id_colegio, this.id_ano_lectivo);
      this.getPeriodos(this.id_colegio, this.id_ano_lectivo);
    },
    /*_________________________
    |   PETICIONES AL BACK   */
    async getNiveles(id_ano_lectivo, id_colegio) {
      try {
        let niveles = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/getNiveles",
          { id_ano_lectivo: id_ano_lectivo, id_colegio: id_colegio }
        );

        let nivelesList = niveles.data.length == 0 ? new Array() : niveles.data;
        this.niveles = nivelesList;

      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Error al traer los niveles.",
          tiempo: 3000,
        });
      }
    },

    async filterSelectFields(value) {

      const filteredAlumnos = this.alumnosBackup.filter(alumno => alumno.desc_nivel === value.desc_nivel);
      this.alumnos = filteredAlumnos;

      console.log("alumnos: ", this.alumnos)
      console.log("alumnosBackup: ", this.alumnosBackup)
    },

    async getGrados(idNivel, id_colegio, id_ano_lectivo) {
      try {
        let grados = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/getGrados",
          {
            idNivel: idNivel,
            id_colegio: id_colegio,
            id_ano_lectivo: id_ano_lectivo,
          }
        );

        let gradosList = grados.data.length == 0 ? new Array() : grados.data;
        this.grados = gradosList;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Error al traer los grados.",
          tiempo: 3000,
        });
      }
    },

    async getSecciones(idGrado, id_ano_lectivo, id_colegio) {
      try {
        let grados = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/getGrados",
          {
            idNivel: this.nivelSelected,
            id_colegio: id_colegio,
            id_ano_lectivo: id_ano_lectivo,
          }
        );

        let gradosList = grados.data.length == 0 ? new Array() : grados.data;
        this.grados = gradosList;

        let secciones = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/getSecciones",
          {
            idGrado: idGrado,
            id_ano_lectivo: id_ano_lectivo,
            id_colegio: id_colegio,
          }
        );

        let seccionesList =
          secciones.data.length == 0 ? new Array() : secciones.data;
        this.secciones = seccionesList;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Error al traer las secciones.",
          tiempo: 3000,
        });
      }
    },
    //Aqui tendro esta la logica tanto del (Disabld button 'Cierre FInal') y el header dinamico de los periodos
    async getPeriodos(id_colegio, id_ano_lectivo) {
      
      try {
      this.headers= [
        {
          text: "Nombre y apellidos",
          value: "apellido_nombre",
          class: "header_datatable",
        },
        {
          text: "Nivel",
          value: "desc_nivel",
          class: "header_datatable",
        },
        {
          text: "Grado",
          value: "desc_grado",
          class: "header_datatable",
        },
        {
          text: "Sección",
          value: "nombre_seccion",
          class: "header_datatable",
        },
      ]

        let periodos = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/getPeriodos",
          {
            id_colegio: id_colegio,
            id_ano_lectivo: id_ano_lectivo,
          }
        );

        //Logica para desabilitar el button 'Cierre Final', si el ultimo periodo aun no finaliza.
        let ultimoPeriodo = periodos.data.reduce((prev, current) => {
          return new Date(prev.fecha_cierre) > new Date(current.fecha_cierre)
            ? prev
            : current;
        });

        let hoy = new Date().toISOString().slice(0, 10); //Convertir el tipo de hora para que coincida con el de la bd
        this.periodosDisableButton = ultimoPeriodo.fecha_cierre > hoy;

        //Logica para obtener nombre de los periodos para el Header
        let nombre_periodo = periodos.data.map((e) => e.nombre_periodo);
        this.periodos = [...new Set(nombre_periodo)];

        // Mapear cada periodo a su columna correspondiente
        this.periodos.forEach((periodo) => {
          this.headers.push({
            text: periodo,
            value: "periodos." + periodo,
            class: "header_datatable",
            sortable: false,
          });
        });

        this.headers.push(
          {
            text: "Nota",
            value: "nivel_logro_anual",
            class: "header_datatable",
          },
          {
            text: "Situación",
            value: "situacion",
            class: "header_datatable",
          }
        );
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Error al traer los periodos.",
          tiempo: 3000,
        });
      }
    },

    async getAlumnos(id_colegio, id_ano_lectivo, id_seccion) {
   
      try {
        let response = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/getAlumnos",
          {
            id_colegio: id_colegio,
            id_ano_lectivo: id_ano_lectivo,
            id_seccion: id_seccion,
          }
        );

        this.alumnos = response.data;
        this.alumnosBackup = response.data;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "Error al traer a los estudiantes.",
        });
      }
    },
    /*____________________________________
    |   DISPARADORES Y FNS() DE APOYO   */
    SeleccionarNivel(idNivel) {
      this.gradoSelected = -1;
      this.seccionSelected = -1;
      this.secciones = [];
      this.nivelSelected = idNivel.id_nivel;
      this.getGrados(idNivel.id_nivel, this.id_colegio, this.id_ano_lectivo);
      this.filterFieldsByNivel(idNivel)
    },

    async filterFieldsByNivel(data){
      const alumnosByNivel = this.alumnosBackup.filter(alumno => alumno.desc_nivel === data.desc_nivel);
      this.alumnos = alumnosByNivel;
      this.nivelesBackup = alumnosByNivel;
    },

    SeleccionarGrado(idGrado) {
      this.getSecciones(idGrado.id, this.id_ano_lectivo, this.id_colegio);
      this.filterFieldsByGrado(idGrado)
    },

    async filterFieldsByGrado(data){    
      const alumnosByGrado = this.nivelesBackup.filter(alumno => alumno.desc_grado === data.desc_grado);
      this.alumnos = alumnosByGrado;
      this.gradosBackup = alumnosByGrado
    },

    SeleccionarSeccion(idSeccion) {
      this.seccionSelected = idSeccion;
      this.filterFieldsBySeccion(idSeccion)
    },

    async filterFieldsBySeccion(data){
      const alumnosBySeccion = this.gradosBackup.filter(alumno => alumno. nombre_seccion === data.nombre_seccion);
      this.alumnos = alumnosBySeccion
    },

    //Abrir modal de estadisticas
    openStatistics() {
      this.dialogChart = true;
    },


    /*_______________
    |   LIMPIADOR  */
    Limpiador() {
      (this.alumnos = []),
        (this.periodos = []),
        (this.grados = []),
        (this.secciones = []),
        (this.nivelSelected = -1),
        (this.gradoSelected = -1),
        (this.seccionSelected = -1),
        this.getAlumnos(this.id_colegio, this.id_ano_lectivo);
    },

    CloseComp() {
      this.dialogConfi = false;
      this.estadoComp = false;
    },
  },
};
</script>

<style>
.v-chart {
  width: 100%;
  height: 400px;
}
</style>
